// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NbjV","controls":"styles_controls__17hVn","charLimit":"styles_charLimit__1mUZU","input":"styles_input__1bDMQ","send":"styles_send__nU-bC"};